import { Button, Col, Label, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import BlkFormik from "../coms/BlkFormik";
import { Form } from "formik";
import React, { useRef, useState } from "react";
import JedaiTooltip from "../coms/JedaiTooltip";
import { BlkField } from "../coms/BlkField";
import BlkDropImg from "../coms/BlkDropImg";
import Alerts from "./Alerts";
import axios from "axios";
import { routes } from "../gen/General";

export const ModalImportExcel = ({ baseUrl, titulo, open, setOpen, item, ...props }) => {
    const alert = useRef(null);
    const [visible, setVisible] = useState(false);
    const [subidas, setSubidas] = useState(0);
    const [actualizadas, setActualizadas] = useState(0);
    const [fallidas, setFallidas] = useState([]);
    const ACCEPT = "application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"; // .xls .xlsx
    const image_file_size = 10 * 1024 * 1024; // 10MB

    function descargarPlantilla() {
        axios
            .get(routes.api + baseUrl + "/plantilla", {
                responseType: "arraybuffer",
            })
            .then(resp => {
                let blob = new Blob([resp.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                let linkExcel = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = linkExcel;
                const fileName = "Plantilla_" + titulo + ".xlsx";
                link.setAttribute("download", fileName);
                document.body.appendChild(link);
                link.click();
            })
            .catch(error => {
                alert.current.handle_error(error);
            });
    }

    function onSubmit(newValues, actions) {
        setVisible(true);
        let file = newValues.file;
        if (file === null || file === undefined) {
            alert.current.show_error("Seleccione un archivo excel");
            setVisible(false);
            actions.setSubmitting(false);
        } else {
            newValues.file = undefined;
            let formData = new FormData();
            formData.append("file", file);
            axios
                .post(routes.api + baseUrl + "/importar", formData)
                .then(resp => {
                    if (props?.asincrono) {
                        props?.closeImportar();
                    }
                    let data = resp.data;
                    setSubidas(data.subidas);
                    setFallidas(data.fallidas);
                    setActualizadas(data.actualizadas);
                    alert.current.show_info("Importación completa, si algún dato es repetido será actualizado");
                })
                .catch(error => {
                    alert.current.handle_error(error);
                })
                .then(() => {
                    actions.setSubmitting(false);
                    setVisible(false);
                });
        }
    }

    return (
        <Modal isOpen={open} size="lg">
            <Alerts ref={alert} />
            <div className="container">
                <ModalHeader className="justify-content-center title py-1" tag="h4">
                    Importar {titulo}
                    <button
                        type="button"
                        className="close py-0"
                        title="Cerrar"
                        onClick={() => {
                            setOpen(false);
                            setSubidas(0);
                            setActualizadas(0);
                            setFallidas([]);
                        }}
                        aria-label="Close"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </ModalHeader>
                <ModalBody>
                    <Col md={12}>
                        <BlkFormik
                            initialValues={item}
                            onSubmit={onSubmit}
                            enableReinitialize={true}
                            validateOnChange={false}
                        >
                            {({ isSubmitting, submitForm }) => (
                                <Form>
                                    <Row>
                                        <div className="form-group col-lg-12">
                                            <Label>
                                                Seleccionar Excel: &nbsp;&nbsp;
                                                <a
                                                    href={"#"}
                                                    onClick={() => {
                                                        descargarPlantilla();
                                                    }}
                                                >
                                                    <b>Ver Plantilla&nbsp;</b>
                                                </a>
                                                <JedaiTooltip
                                                    className="icon-info"
                                                    placement="right"
                                                    message={
                                                        "Descargue la plantilla e ingrese los datos de acuerdo al orden establecido en la misma."
                                                    }
                                                >
                                                    <i className="fas fa-info-circle" />
                                                </JedaiTooltip>
                                            </Label>
                                            <BlkField
                                                name="file"
                                                accept={ACCEPT}
                                                maxSize={image_file_size}
                                                className="col-md-9 px-0"
                                                component={BlkDropImg}
                                            />
                                        </div>
                                    </Row>
                                    <Row>
                                        <Col md={6}>
                                            <Button
                                                color="danger"
                                                className={"mx-2"}
                                                onClick={() => {
                                                    setOpen(false);
                                                    setSubidas(0);
                                                    setActualizadas(0);
                                                    setFallidas([]);
                                                }}
                                            >
                                                Cerrar
                                            </Button>
                                        </Col>
                                        <Col md={6} className={"text-right"}>
                                            <Button
                                                color="primary"
                                                disabled={isSubmitting}
                                                className={"mx-2"}
                                                onClick={submitForm}
                                            >
                                                Importar
                                            </Button>
                                        </Col>
                                        <div className="col-12">
                                            {props?.msg && (
                                                <>
                                                    <p className={"mt-3"}>
                                                        <b>{props.msg}</b>
                                                    </p>
                                                </>
                                            )}
                                        </div>
                                    </Row>
                                    <br />
                                    <br />
                                    {visible && (
                                        <Row>
                                            <Col md={12} className={"text-right"}>
                                                <br />
                                                Importando... Por favor espere...
                                            </Col>
                                        </Row>
                                    )}
                                </Form>
                            )}
                        </BlkFormik>
                        <Row>
                            <Col md={12}>
                                <span>
                                    <b>Importados con éxito:</b> &nbsp;&nbsp;{subidas}
                                </span>
                                <br />
                                <span>
                                    <b>Actualizadas:</b> &nbsp;&nbsp;{actualizadas}
                                </span>
                                <br />
                                <span>
                                    <b>Errores:</b> &nbsp;&nbsp;{fallidas?.length}
                                </span>
                                <br />
                            </Col>
                            {fallidas?.length > 0 && (
                                <Col md={12}>
                                    <h4 className={"text-center"}>{"Fallidas"}</h4>
                                    <div className="table-responsive mb-5">
                                        <table className="table table-borderless table-striped table-hover">
                                            <thead className="text-primary">
                                                <tr className="text-center">
                                                    <th>#</th>
                                                    <th>Nombre - Razón del fallo</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {fallidas.map((error, index) => (
                                                    <tr className="text-center" key={error}>
                                                        <td>{index + 1}</td>
                                                        <td>{error}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </Col>
                            )}
                        </Row>
                    </Col>
                </ModalBody>
            </div>
        </Modal>
    );
};
